// 大运会
export default {
  data() {
    return {
      bigSportsList: [
        {
          id: 'ARC',
          CN: '射箭',
          EN: 'Archery',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_1',
              },
            ],
            // D: [
            //   {
            //     startList: 'mode_3',
            //     localData: 'mode_1',
            //   },
            // ],
            // T: [
            //   {
            //     startList: 'mode_3',
            //     localData: 'mode_1',
            //   },
            // ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_2',
              },
            ],
            // D: [
            //   {
            //     startList: 'mode_4',
            //     localData: 'mode_2',
            //   },
            // ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_2',
              },
            ],
          },
        },
        {
          id: 'ATH',
          CN: '田径',
          EN: 'Athletics',
          uncombat: {
            A: [
              {
                //比如A里面有多个元素时，则该同大项且同非对抗类且同单人的情况下存在多种视图，需要用小项进一步区别；如果只有一个元素则取默认的视图
                startList: 'mode_3',
                localData: 'mode_9',
                specialEventArr: [
                  // 男子
                  'ATHMHMARATHO----------------------', // 半马
                  'ATHMHIGHJUMP----------------------', // 跳高
                  'ATHMLONGJUMP----------------------', // 跳远
                  'ATHMTRPLJUMP----------------------', // 三级跳远
                  'ATHMSHOTPUT-----------------------', // 铅球
                  'ATHMDISCUS------------------------', // 铁饼
                  'ATHMHAMMER------------------------', // 链球
                  'ATHMJAVELIN-----------------------', // 标枪
                  'ATHMPLEVAULT----------------------', // 撑竿跳高
                  // 女子
                  'ATHWHMARATHO----------------------', // 半马
                  'ATHWHIGHJUMP----------------------', // 跳高
                  'ATHWLONGJUMP----------------------', // 跳远
                  'ATHWTRPLJUMP----------------------', // 三级跳远
                  'ATHWSHOTPUT-----------------------', // 铅球
                  'ATHWDISCUS------------------------', // 铁饼
                  'ATHWHAMMER------------------------', // 链球
                  'ATHWJAVELIN-----------------------', // 标枪
                  'ATHWPLEVAULT----------------------', // 撑竿跳高
                ], //特殊视图：同大项且同非对抗类且同单人的情况下，通过小项区分另外的视图
              },
              {
                //比如A里面有多个元素时，则该同大项且同非对抗类且同单人的情况下存在多种视图，需要用小项进一步区别；如果只有一个元素则取默认的视图
                startList: 'mode_3',
                localData: 'mode_9',
                specialEventArr: [
                  'ATHMDECATH------------------------', //男子 十项全能
                  'ATHWHEPTATH-----------------------', // 女子 七项全能
                ], //特殊视图：通过小项已经不能区分本场数据视图了，出场名单都一样；因此只能比赛名字title中是否包含【跳高、跳远、标枪】等字段区分，幸好【全能】里面只有2视图
                localDataTitleArr: [
                  '跳远',
                  '铅球',
                  '跳高',
                  '铁饼',
                  '撑竿跳高',
                  '标枪',
                ], //只是本场数据：属于数组中的是mode_9，其他都是mode_3
                defaultEventCompMode: ['mode_3', 'mode_3'], //如果都符合，则取默认视图；【startList默认视图，localData默认视图】
              },
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'BDM',
          CN: '羽毛球',
          EN: 'Badminton',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_11',
                localData: 'mode_12',
              },
            ],
          },
        },
        {
          id: 'BKB',
          CN: '篮球',
          EN: 'Basketball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'DIV',
          CN: '跳水',
          EN: 'Diving',
          routePageArr: [
            {
              // 男子团体 || 女子团体
              eventIdArr: [
                'DIVMTEAM--------------------------',
                'DIVWTEAM--------------------------',
              ],
              tabArr: [
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: true,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3', //'开发mode_23，测试使用',
                localData: 'mode_10',
              },
            ],
            D: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
                specialEventArr: [
                  'DIVXTEAM--------------------------', //混合团体
                ],
              },
              {
                startList: '', //男子团体 || 女子团体没有出场名单
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'FEN',
          CN: '击剑',
          EN: 'Fencing',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_19',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_19_19',
              },
            ],
          },
        },
        {
          id: 'GAR',
          CN: '体操',
          EN: 'Artistic Gymnastics',
          routePageArr: [
            {
              // 男子团体 || 女子团体
              eventIdArr: [
                'GARM------------------------------',
                'GARMTEAM--------------------------',
                'GARW------------------------------',
                'GARWTEAM--------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '轮次成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'teamResult',
                  name: '团体成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'combinedResult',
                  name: '全能成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 男子个人全能 || 女子个人全能
              eventIdArr: [
                'GARM1AA---------------------------',
                'GARW1AA---------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '轮次成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'combinedResult',
                  name: '全能成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: '',
                roundResult: 'mode_18',
                singleResult: 'mode_17',
                combinedResult: 'mode_3',
                specialEventArr: [
                  'GARM1APVT-------------------------', //男子跳马
                  'GARW1APVT-------------------------', // 女子跳马
                ],
              },
              {
                startList: 'mode_18',
                localData: '',
                roundResult: 'mode_18',
                singleResult: '',
                combinedResult: 'mode_3',
                specialEventArr: [
                  'GARM1AA---------------------------', //男子个人全能
                  'GARW1AA---------------------------', // 女子个人全能
                ],
              },
              {
                startList: 'mode_18',
                localData: '',
                roundResult: 'mode_18',
                teamResult: 'mode_10',
                combinedResult: 'mode_3',
                singleResult: 'mode_16',
                specialEventArr: [
                  'GARM------------------------------', //男子团体
                  'GARMTEAM--------------------------',
                  'GARW------------------------------', // 女子团体
                  'GARWTEAM--------------------------',
                ],
              },
              {
                startList: 'mode_3',
                localData: '',
                roundResult: 'mode_18',
                singleResult: 'mode_3',
                combinedResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'GRY',
          CN: '艺术体操',
          EN: 'Rhythmic Gymnastics',
          routePageArr: [
            {
              // 个人全能 || 集体全能
              eventIdArr: [
                'GRYW1AA---------------------------',
                'GRYW5AA---------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'combinedResult',
                  name: '全能成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
                roundResult: 'mode_16',
                singleResult: 'mode_16',
                combinedResult: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_14',
                localData: '',
                roundResult: 'mode_16',
                singleResult: 'mode_16',
                combinedResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'JUD',
          CN: '柔道',
          EN: 'Judo',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_13',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_19',
              },
            ],
          },
        },
        {
          id: 'ROW',
          CN: '赛艇',
          EN: 'Rowing',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            D: [
              {
                startList: 'mode_14',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_14',
                localData: 'mode_9',
              },
            ],
          },
        },
        {
          id: 'SHO',
          CN: '射击',
          EN: 'Shooting',
          uncombat: {
            A: [
              {
                startList: 'mode_20',
                localData: 'mode_17',
                specialEventArr: [
                  'SHOMRFP---------------------------', //男子25米手枪速射
                  'SHOWSP----------------------------', //女子25米运动手枪
                ],
                startListTitleArr: ['资格赛'],
                defaultEventCompMode: ['mode_3', 'mode_17'],
              },
              {
                startList: 'mode_3',
                localData: 'mode_17',
              },
            ],
            T: [
              {
                startList: 'mode_3',
                localData: 'mode_21',
                specialEventArr: [
                  'SHOXAPMIX-------------------------', //混合团体10米气手枪
                  'SHOXARMIX-------------------------', //混合团体10米气步枪
                ],
                localDataTitleArr: ['资格赛'],
                startListTitleArr: ['资格赛'],
                defaultEventCompMode: ['mode_20', 'mode_22'],
              },
              {
                startList: 'mode_3',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'SWM',
          CN: '游泳',
          EN: 'Swimming',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'TEN',
          CN: '网球',
          EN: 'Tennis',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
          },
        },
        {
          id: 'TKW',
          CN: '跆拳道',
          EN: 'Taekwondo',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_17_17',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_17_17',
              },
            ],
          },
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
            D: [
              //混合双人品势
              {
                startList: 'mode_10',
                localData: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'TTE',
          CN: '乒乓球',
          EN: 'Table Tennis',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_8',
              },
            ],
          },
        },
        {
          id: 'VVO',
          CN: '排球',
          EN: 'Volleyball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'WPO',
          CN: '水球',
          EN: 'Water Polo',
          combat: {
            T: [
              {
                startList: 'mode_4',
                // localData: 'complexTypeMode_6_5',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'WSU',
          CN: '武术',
          EN: 'Wushu',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_13',
                localData: 'mode_13',
              },
            ],
          },
        },
      ],
    }
  },
}
